import { useState } from "react";
import { Copy, Check, Link2, Coins, Lock } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "./Reveal";

const CONTRACT = "AqmPAcCeriGA6TAq2ZUsowAeWcktZ7VVrYsjAA1zpump";

const CARDS = [
  {
    Icon: Link2,
    label: "BLOCKCHAIN",
    value: "SOLANA",
    border: "border-[#B6FF00]/40 hover:border-[#B6FF00]",
    shadow: "shadow-[0_0_20px_rgba(182,255,0,0.15)] hover:shadow-[0_0_35px_rgba(182,255,0,0.4)]",
    color: "text-[#B6FF00]",
    glow: "glow-green",
    testid: "tokenomics-card-blockchain",
  },
  {
    Icon: Coins,
    label: "TOKEN",
    value: "$HALLOWIN",
    border: "border-[#FF6B00]/40 hover:border-[#FF6B00]",
    shadow: "shadow-[0_0_20px_rgba(255,107,0,0.15)] hover:shadow-[0_0_35px_rgba(255,107,0,0.4)]",
    color: "text-[#FF6B00]",
    glow: "glow-orange",
    testid: "tokenomics-card-token",
  },
  {
    Icon: Lock,
    label: "TOTAL SUPPLY",
    value: "1B",
    sub: "80% LOCKED",
    border: "border-[#A020F0]/40 hover:border-[#A020F0]",
    shadow: "shadow-[0_0_20px_rgba(160,32,240,0.15)] hover:shadow-[0_0_35px_rgba(160,32,240,0.45)]",
    color: "text-[#A020F0]",
    glow: "glow-purple",
    testid: "tokenomics-card-supply",
  },
];

export const Tokenomics = () => {
  const [copied, setCopied] = useState(false);

  const copyContract = async () => {
    try {
      await navigator.clipboard.writeText(CONTRACT);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = CONTRACT;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success("Contract address copied. Stay spooky. 🎃");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section id="tokenomics" className="relative z-10 py-20 lg:py-32 px-4 sm:px-8" data-testid="tokenomics-section">
      <div className="max-w-6xl mx-auto">
        <Reveal className="text-center">
          <p className="mono text-xs tracking-[0.35em] text-[#FF6B00] glow-orange mb-4">// THE NUMBERS</p>
          <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl lg:text-5xl" data-testid="tokenomics-title">
            <span className="glitch text-[#B6FF00] glow-green" data-text="THE SPOOKYNOMICS">
              THE SPOOKYNOMICS
            </span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {CARDS.map(({ Icon, label, value, sub, border, shadow, color, glow, testid }, i) => (
            <Reveal key={label} delay={i * 0.12}>
              <div
                className={`neon-card border ${border} ${shadow} text-center group hover:-translate-y-2`}
                data-testid={testid}
              >
                <Icon className={`w-10 h-10 mx-auto ${color} group-hover:scale-125 transition-transform duration-300`} />
                <p className="mono text-xs tracking-[0.3em] text-purple-300/70 mt-5">{label}</p>
                <p className={`font-display font-bold text-3xl sm:text-4xl mt-2 ${color} ${glow}`}>{value}</p>
                {sub && <p className="mono text-xs tracking-[0.25em] text-[#B6FF00] mt-3">{sub}</p>}
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3}>
          <div
            className="mt-10 neon-card border border-[#A020F0]/40 shadow-[0_0_25px_rgba(160,32,240,0.2)] flex flex-col sm:flex-row items-center gap-4 sm:gap-6"
            data-testid="contract-address-box"
          >
            <div className="mono text-xs tracking-[0.3em] text-[#A020F0] glow-purple whitespace-nowrap">CONTRACT</div>
            <code
              className="mono text-xs sm:text-sm text-[#B6FF00] break-all text-center sm:text-left flex-1"
              data-testid="contract-address-text"
            >
              {CONTRACT}
            </code>
            <button
              onClick={copyContract}
              data-testid="copy-contract-button"
              className="bg-[#19002E] text-[#B6FF00] border border-[#B6FF00]/50 hover:bg-[#B6FF00] hover:text-black font-bold mono text-sm px-5 py-2.5 rounded-lg transition-all duration-200 flex items-center gap-2 shrink-0 hover:scale-105 active:scale-95"
            >
              {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
              {copied ? "COPIED" : "COPY"}
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
